/* import __COLOCATED_TEMPLATE__ from './bounce-bubble.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();